export const FIREBASE_CREDENTIALS = {
  apiKey: "AIzaSyAg43o9dBd0uZMaX-JmzDJ5UhOJl4QJ4kw",
  authDomain: "philips-academy-coffee.firebaseapp.com",
  databaseURL: "https://philips-academy-coffee.firebaseio.com",
  projectId: "philips-academy-coffee",
  storageBucket: "philips-academy-coffee.appspot.com",
  messagingSenderId: "875660932985",
  appId: "1:875660932985:web:3cb2c3f2c63636a772e1a8",
};

export const GOOGLE_RECAPTCHA_SITE_KEY =
  "6LfBQdgZAAAAABFSjq9swn4DOzOo8uvx6D0HE3Qf";

export const STRIPE_PUBLISHABLE_KEY =
  process.env.NODE_ENV === "development"
    ? "pk_test_51IHV1EDNscYWipcfQiod8L2UbpazMwx8GWwnoNFBr4koiTDfa4CFiilQXRg22q7rhSQJlU8i2Ni8Lx9t6oqlus4o00TbEcuWJR"
    : "pk_live_51IHV1EDNscYWipcfFHwEc1Q4mASsXn9dVEp5mPrKnIPD3dnKyZgEaEn53RkUoYq0h6dTtWIhZfbwITveVLg96Kng00IrIwky1L";
